import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className='navbar-container'>
        <Link to='/' className='navbar-logo'>
          <img src='/motoGuruLogoMain.svg' alt='MotoGuru Logo' className='navbar-logo-image' />
          MotoGuru <span className='logo-accent'>AI</span>
        </Link>

        {/* Desktop Navigation */}
        {!isMobile && (
          <div className='navbar-menu'>
            <Link to='/' className={`navbar-link ${location.pathname === '/' ? 'active' : ''}`}>
              Home
            </Link>
            <Link to='/about' className={`navbar-link ${location.pathname === '/about' ? 'active' : ''}`}>
              About Us
            </Link>
            <Link to='/feedback' className={`navbar-link ${location.pathname === '/feedback' ? 'active' : ''}`}>
              Feedback
            </Link>
          </div>
        )}

        {/* Mobile Navigation */}
        {isMobile && (
          <>
            <button className={`menu-toggle ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu} aria-label='Toggle menu'>
              <span className='menu-bar'></span>
            </button>

            <div className={`mobile-menu ${isMenuOpen ? 'active' : ''}`}>
              <div className='mobile-menu-content'>
                <Link to='/' className={`mobile-link ${location.pathname === '/' ? 'active' : ''}`} onClick={() => setIsMenuOpen(false)}>
                  Home
                </Link>
                <Link to='/about' className={`mobile-link ${location.pathname === '/about' ? 'active' : ''}`} onClick={() => setIsMenuOpen(false)}>
                  About Us
                </Link>
                <Link to='/feedback' className={`mobile-link ${location.pathname === '/feedback' ? 'active' : ''}`} onClick={() => setIsMenuOpen(false)}>
                  Feedback
                </Link>
              </div>
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
